import React from 'react';
import './index.css';
import { Button } from 'antd';

export const BreathingImage = ({ src1, src2, alt, desc, clickHandler }) => {
  if (!src2) {
    return null;
  }

  return (
    <div className="breathing-container">
      <img src={src1} alt={alt} className="top-image" />
      <img src={src2} alt={alt} className="bottom-image" />
      <div className={'overlay-content'}>
        <div style={{ fontSize: 36, fontWeight: 600, marginBottom: 24 }}>
          {alt}
        </div>
        <div
          style={{
            width: '40%',
            maxWidth: '620px',
            fontSize: 20,
            lineHeight: 1.8,
            marginBottom: 70,
          }}
        >
          {desc}
        </div>
        <Button
          size={'large'}
          type={'primary'}
          onClick={clickHandler}
          style={{ width: 108 }}
        >
          了解详情
        </Button>
      </div>
    </div>
  );
};
